import { SDKConfiguration } from "@/inference/setup/config";
import { InferenceResult } from "./utils/infer-from-weights";
import { EcommerceSecondaryAttributes } from "./ecomm/types";

export async function getPersonaInferences(
  body: any,
): Promise<InferenceResult> {
  const response = await fetch(SDKConfiguration.PERSONA_INFERENCES, {
    method: "POST",
    body: JSON.stringify(body),
  });
  const data = await response.json();

  return data;
}

type ReturnType = {
  ecommerce: {
    fromEcommerce: InferenceResult;
    secondaryAttributes: EcommerceSecondaryAttributes & {
      temp: any;
    };
  };

  behavior: {
    fromBehavior: InferenceResult;
  };

  mergedInference: InferenceResult["inference"];
  strongestInference: InferenceResult["strongestInference"];
};

export async function getBehaviorAndEcommInferences(
  body: any,
): Promise<ReturnType> {
  const response = await fetch(SDKConfiguration.BEHAVIOR_AND_ECOMM_INFERENCES, {
    method: "POST",
    body: JSON.stringify(body),
  });
  const data = await response.json();

  return data;
}
